<div [ngClass]="data!=null?'main-container-edit':'main-container'" *ngIf="canInsert">
    <div class="view-component-title" *ngIf="data!=null">{{title}}</div>
    <ngx-spinner bdColor="rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()" size="medium" color="#fff" type="ball-clip-rotate-multiple" [fullScreen]="false" name="media-loading">
    </ngx-spinner>

    <div [ngClass]="data!=null?'video-super-edit default-bg':'video-super default-bg'" [hidden]="state!='RECORDED'">
        <nz-progress *ngIf="showProgressBar" [nzPercent]="videoRecordingService.progress" nzStrokeWidth="6"></nz-progress>

        <video #videoElement class="video-container" controls autoplay playsInline [src]="videoBlobUrlSrc"></video>

        <div [ngClass]="data!=null?'save-button-edit default-bg':'save-button default-bg'">
            <nz-radio-group [(ngModel)]="fileAction" (ngModelChange)="onFileActionChange($event)" nz-button-style="solid">
                <label nz-radio-button nzValue="save" *ngIf="data==null"><i nz-icon nzType="save"></i>&nbsp;{{'save'|translateTA}}</label>
                <label nz-radio-button nzValue="download"><i nz-icon nzType="download"></i>&nbsp;{{'download'|translateTA}}</label>
                <label nz-radio-button nzValue="clear"><i nz-icon nzType="delete"></i>&nbsp;{{'clear'|translateTA}}</label>
            </nz-radio-group>
        </div>
    </div>

    <div class="float-button" *ngIf="showFloatButton">
        <nz-radio-group [(ngModel)]="recordAction" (ngModelChange)="onRecordActionChange($event)" nz-button-style="solid">
            <label nz-radio-button nzValue="record" [nzDisabled]="state=='RECORDING'"><i nz-icon nzType="video-camera"></i>&nbsp;{{'record'|translateTA}}</label>
            <label nz-radio-button nzValue="stop" [nzDisabled]="state!='RECORDING'"><i nz-icon nzType="stop"></i>&nbsp;{{'stop'|translateTA}}</label>
        </nz-radio-group>
    </div>

</div>